"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import DropListItemContentMediaAudio from "./DropListItemContentMediaAudio";
import { ImageScale } from "@/helpers/image.helpers";
import DropListItemContentMediaImage from "./DropListItemContentMediaImage";
import DropListItemContentMediaVideo from "./DropListItemContentMediaVideo";
import MediaDisplay from "./MediaDisplay";
enum MediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  GLB = "GLB",
  HTML = "HTML",
  UNKNOWN = "UNKNOWN",
}
const DropListItemContentMediaGLB = dynamic(() => import("./DropListItemContentMediaGLB"), {
  ssr: false
});
export default function DropListItemContentMedia(t0) {
  const $ = _c(37);
  const {
    media_mime_type,
    media_url,
    onContainerClick,
    isCompetitionDrop: t1,
    disableModal: t2,
    disableAutoPlay: t3,
    imageObjectPosition,
    imageScale: t4,
    htmlIframeContainerClassName,
    htmlPreviewImageUrl
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const disableModal = t2 === undefined ? false : t2;
  const disableAutoPlay = t3 === undefined ? false : t3;
  const imageScale = t4 === undefined ? ImageScale.AUTOx800 : t4;
  let t5;
  if ($[0] !== media_mime_type || $[1] !== media_url) {
    t5 = () => {
      if (media_mime_type.includes("image")) {
        return MediaType.IMAGE;
      }
      if (media_mime_type.includes("video")) {
        return MediaType.VIDEO;
      }
      if (media_mime_type.includes("audio")) {
        return MediaType.AUDIO;
      }
      if (media_mime_type === "model/gltf-binary" || media_mime_type === "model/gltf+json" || media_url.endsWith(".glb") || media_url.endsWith(".gltf")) {
        return MediaType.GLB;
      }
      if (media_mime_type === "text/html") {
        return MediaType.HTML;
      }
      return MediaType.UNKNOWN;
    };
    $[0] = media_mime_type;
    $[1] = media_url;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const getMediaType = t5;
  let t6;
  if ($[3] !== disableAutoPlay || $[4] !== disableModal || $[5] !== getMediaType || $[6] !== htmlIframeContainerClassName || $[7] !== htmlPreviewImageUrl || $[8] !== imageObjectPosition || $[9] !== imageScale || $[10] !== isCompetitionDrop || $[11] !== media_mime_type || $[12] !== media_url || $[13] !== onContainerClick) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const mediaType = getMediaType();
      switch (mediaType) {
        case MediaType.IMAGE:
          {
            let t7;
            if ($[15] !== disableModal || $[16] !== imageObjectPosition || $[17] !== imageScale || $[18] !== isCompetitionDrop || $[19] !== media_url || $[20] !== onContainerClick) {
              t7 = <DropListItemContentMediaImage src={media_url} onContainerClick={onContainerClick} isCompetitionDrop={isCompetitionDrop} disableModal={disableModal} imageObjectPosition={imageObjectPosition} imageScale={imageScale} />;
              $[15] = disableModal;
              $[16] = imageObjectPosition;
              $[17] = imageScale;
              $[18] = isCompetitionDrop;
              $[19] = media_url;
              $[20] = onContainerClick;
              $[21] = t7;
            } else {
              t7 = $[21];
            }
            t6 = t7;
            break bb0;
          }
        case MediaType.VIDEO:
          {
            let t7;
            if ($[22] !== disableAutoPlay || $[23] !== media_url) {
              t7 = <DropListItemContentMediaVideo src={media_url} disableAutoPlay={disableAutoPlay} />;
              $[22] = disableAutoPlay;
              $[23] = media_url;
              $[24] = t7;
            } else {
              t7 = $[24];
            }
            t6 = t7;
            break bb0;
          }
        case MediaType.AUDIO:
          {
            let t7;
            if ($[25] !== media_url) {
              t7 = <DropListItemContentMediaAudio src={media_url} />;
              $[25] = media_url;
              $[26] = t7;
            } else {
              t7 = $[26];
            }
            t6 = t7;
            break bb0;
          }
        case MediaType.GLB:
          {
            let t7;
            if ($[27] !== media_url) {
              t7 = <DropListItemContentMediaGLB src={media_url} />;
              $[27] = media_url;
              $[28] = t7;
            } else {
              t7 = $[28];
            }
            t6 = t7;
            break bb0;
          }
        case MediaType.HTML:
          {
            let t7;
            if ($[29] !== disableAutoPlay || $[30] !== htmlIframeContainerClassName || $[31] !== htmlPreviewImageUrl || $[32] !== imageScale || $[33] !== media_mime_type || $[34] !== media_url) {
              t7 = <MediaDisplay media_mime_type={media_mime_type} media_url={media_url} imageScale={imageScale} previewImageUrl={htmlPreviewImageUrl} requireInteractionToLoad={disableAutoPlay} iframeContainerClassName={htmlIframeContainerClassName} />;
              $[29] = disableAutoPlay;
              $[30] = htmlIframeContainerClassName;
              $[31] = htmlPreviewImageUrl;
              $[32] = imageScale;
              $[33] = media_mime_type;
              $[34] = media_url;
              $[35] = t7;
            } else {
              t7 = $[35];
            }
            t6 = t7;
            break bb0;
          }
        case MediaType.UNKNOWN:
          {
            let t7;
            if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
              t7 = <></>;
              $[36] = t7;
            } else {
              t7 = $[36];
            }
            t6 = t7;
            break bb0;
          }
        default:
          {
            t6 = assertUnreachable(mediaType);
            break bb0;
          }
      }
    }
    $[3] = disableAutoPlay;
    $[4] = disableModal;
    $[5] = getMediaType;
    $[6] = htmlIframeContainerClassName;
    $[7] = htmlPreviewImageUrl;
    $[8] = imageObjectPosition;
    $[9] = imageScale;
    $[10] = isCompetitionDrop;
    $[11] = media_mime_type;
    $[12] = media_url;
    $[13] = onContainerClick;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
}